//import authMixin from "@/auth/sanctum/authMixin";

export default {
    methods : {
        emitCloseCurrentComponent() {
            //window.console.log('Firing CloseCurrentComponent');
            this.$emit('closeCurrentComponent', true);
        },
        emitForceLoadDefaultLmraComponent(){
            this.$emit('forceLoadDefaultLMRA', true);
        }
    },
    /*mixins : [authMixin]*/
}